import React from 'react';
import { Layout, Menu } from 'antd';
import {
    DashboardOutlined,
    FileTextOutlined,
    CalendarOutlined,
    ClockCircleOutlined,
} from '@ant-design/icons';
import EmployeeLeaves from './EmployeeLeaves';
import EmployeeHR from './EmployeeHR';
import useUrlFilters from 'hooks/useUrlFilters';

const { Sider, Content } = Layout;

const SECTIONS = {
    overview: { component: 'leaves', innerKey: 'overview' },
    applications: { component: 'leaves', innerKey: 'applications' },
    documents: { component: 'hr', innerKey: 'documents' },
    events: { component: 'hr', innerKey: 'events' },
    'hr-attendance': { component: 'hr', innerKey: 'attendance' },
};

// Active section lives in the URL so links to a section's filtered view open on it.
const URL_FILTERS = {
    section: { type: 'string', key: 'ts_section', default: 'overview' },
};

const EmployeeTimesheet = ({ employeeId }) => {
    const [urlFilters, setUrlFilters] = useUrlFilters(URL_FILTERS);
    const active = SECTIONS[urlFilters.section] ? urlFilters.section : 'overview';
    const setActive = (value) => setUrlFilters({ section: value });
    const cur = SECTIONS[active];

    const menuItems = [
        { key: 'overview', icon: <DashboardOutlined />, label: 'Overview' },
        { key: 'applications', icon: <FileTextOutlined />, label: 'Leave Applications' },
        { key: 'documents', icon: <FileTextOutlined />, label: 'Documents' },
        { key: 'events', icon: <CalendarOutlined />, label: 'Events' },
        { key: 'hr-attendance', icon: <ClockCircleOutlined />, label: 'Attendance' },
    ];

    const leavesInner = cur.component === 'leaves' ? cur.innerKey : 'overview';
    const hrInner = cur.component === 'hr' ? cur.innerKey : 'documents';

    return (
        <Layout style={{ height: 'calc(100vh - 280px)', background: '#fff' }}>
            <Sider
                width={240}
                style={{ background: '#fff', borderRight: '1px solid #f0f0f0', overflow: 'auto' }}
            >
                <style>
                    {`
                        .timesheet-sidebar-menu .ant-menu-item-selected {
                            background-color: #1890ff !important;
                            color: #fff !important;
                        }
                        .timesheet-sidebar-menu .ant-menu-item-selected .anticon {
                            color: #fff !important;
                        }
                        .timesheet-sidebar-menu .ant-menu-item-selected::after {
                            border-right-color: #1890ff !important;
                        }
                    `}
                </style>
                <Menu
                    mode="inline"
                    selectedKeys={[active]}
                    onClick={({ key }) => setActive(key)}
                    style={{ borderRight: 0 }}
                    items={menuItems}
                    className="timesheet-sidebar-menu"
                />
            </Sider>
            <Content style={{ background: '#fff', overflow: 'auto' }}>
                <div style={{ display: cur.component === 'leaves' ? 'block' : 'none', height: '100%' }}>
                    <EmployeeLeaves employeeId={employeeId} hideSider activeSection={leavesInner} />
                </div>
                <div style={{ display: cur.component === 'hr' ? 'block' : 'none', height: '100%' }}>
                    <EmployeeHR employeeId={employeeId} hideSider activeSection={hrInner} />
                </div>
            </Content>
        </Layout>
    );
};

export default EmployeeTimesheet;
